// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__4sTY2","title":"styles_title__glGpW","subtitle":"styles_subtitle__QC2Oa"};